import { useState } from "react"

import {
  BaseInput,
  ConcreteInputProps,
  RIGHT_ICON_BUTTON_CLASSES
} from "./BaseInput"

export const PasswordInput = (props: ConcreteInputProps) => {
  const [hide, setHide] = useState(true)
  return (
    <BaseInput
      {...props}
      extraInputClasses={["pr-2.5 placeholder:text-xs"]}
      type={hide ? "password" : "text"}
      rightReactNode={
        <button
          className={`${RIGHT_ICON_BUTTON_CLASSES} mr-2`}
          onClick={() => setHide(!hide)}
          type="button"
        >
          <span className="capitalize text-xs w-8 text-left text-stears_black dark:text-[#9CA3AF]">
            {hide ? "show" : "hide"}
          </span>
        </button>
      }
    />
  )
}
